
namespace RioERP.Reports {
    export class LevelReportColumns {
        static columnsKey = 'Reports.LevelReport';
    }
}